import React, { useEffect, useState } from 'react';

import { MtxButton, MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getApiAccountProfile, useUserLogin } from '@/api';
import { Loader } from '@/components/Loader/loader';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import { log } from '@/utils/functions/logger/logger';

import styles from './styles.module.css';

export const ValidationModificationMdp: React.FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { mutate, isPending } = useUserLogin();
  const { login } = useAuth();

  const pageKey = state.page;
  const didUpdateMdp = state.success;
  const password = state.newMdp;
  const [credentials, setCredentials] = useState({ identifiant: '', motDePasse: '' });

  useEffect(() => {
    setCredentials({
      identifiant: localStorage.getItem('email') || '',
      motDePasse: password,
    });
  }, [password]);

  const Connexion = () => {
    mutate(
      {
        data: {
          identifiant: credentials.identifiant,
          motDePasse: credentials.motDePasse,
        },
      },
      {
        onSuccess: (data) => {
          if (data) {
            log.error(`ValidationModificationMdp Connexion failed`);
            navigate(ROUTE.LOGIN);
            return;
          }

          getApiAccountProfile().then((profileData) => {
            sessionStorage.setItem('islogin', 'true');
            navigate(ROUTE.DASHBOARD);
            login(profileData);
          });
        },
        onError: (error) => {
          log.error(`ValidationModificationMdp Connexion failed: ${error}`);
          navigate(ROUTE.LOGIN);
        },
      }
    );
  };

  if (isPending) return <Loader />;

  return (
    <MtxGrid row>
      <MtxGrid col colLg={6} offsetLg={3} offsetSm={1} colSm={10} colXs={12}>
        <div className={styles.iconValidation}>
          {didUpdateMdp ? (
            <i className={`totem-icon totem-icon-check-circle-solid ${styles.successIconUpdate}`} />
          ) : (
            <i className={`totem-icon totem-icon-warning-solide ${styles.errorIconUpdate}`} />
          )}
        </div>
        <div className={styles.descriptionText}>
          {didUpdateMdp ? (
            <p className={styles.descriptionTitle}>
              Votre mot de passe a été {pageKey === 'reset' ? 'modifié' : 'créé'}.
            </p>
          ) : (
            <>
              <p className={styles.descriptionTitle}>
                Votre demande de {pageKey === 'reset' ? 'modification' : 'création'} de mot de passe n&apos;a pas pu
                aboutir.
              </p>
              <p>Suite à un problème technique, votre opération n&apos;a pas pu aboutir. Veuillez réessayer.</p>
              <p>Si le problème persiste, veuillez contacter votre conseiller.</p>
            </>
          )}
        </div>
        <MtxButton
          className={styles.buttonModification}
          onClick={() => {
            if (didUpdateMdp) Connexion();
            else navigate(ROUTE.RESETPASSWORD);
          }}
          variant="primary"
          size="large"
          full-width
        >
          <div> {didUpdateMdp ? 'Accéder à mon espace client' : 'Réessayer'}</div>
        </MtxButton>
        {!didUpdateMdp && (
          <MtxButton
            onClick={() => {
              navigate(ROUTE.LOGIN);
            }}
            variant="tertiary"
            size="large"
            full-width
          >
            <div>Retour à l&apos;écran de connexion</div>
          </MtxButton>
        )}
      </MtxGrid>
    </MtxGrid>
  );
};
